import "./index.scss";

import { ReactComponent as IconEmptyListPlaceholder } from "assets/images/icons/empty-list-placeholder.svg";
import { FC, memo } from "react";

const ScreenEmptySection: FC = () => {
  return (
    <div className={"empty-section"}>
      <IconEmptyListPlaceholder />
    </div>
  );
};

export default memo(ScreenEmptySection);
